"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Cubby = require("./Cubby");
Object.keys(_Cubby).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Cubby[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Cubby[key];
    }
  });
});